export function filterInfo(state = {}, { filter = {}, type }) {
    switch (type) {
        case 'GET_FILTER':
            return {}
        case 'UPDATE_FILTER':
            return { ...state, ...filter }
        case 'CLEAR_FILTER':
            return filter
        default:
            return state
    }
}
